<template>
  <div class="tabs-container">
    <el-tabs v-model="value" type="card" @tab-click="handleClick">
      <el-tab-pane label="工时统计分析" name="workHourAnalysis">
        <div class="charts-container" v-if="value=='workHourAnalysis'">
          <WorkHourDistChart />
          <work-hour-trend-chart></work-hour-trend-chart>
        </div>

      </el-tab-pane>
      <el-tab-pane label="任务完成率" name="taskCompletion">
        <div class="charts-container" v-if="value=='taskCompletion'">
          <TaskGaugeChart />
          <TaskBarChart />
        </div>

      </el-tab-pane>
      <el-tab-pane label="人均产出" name="perCapitaOutput">
        <div class="charts-container" v-if="value=='perCapitaOutput'">
          <PerOutputRanking />
          <OutputTrendChange />
        </div>
      </el-tab-pane>
      <el-tab-pane label="效率排名" name="efficiencyRanking">
        <div class="charts-container" v-if="value=='efficiencyRanking'">
          <!-- <MultiRadar /> -->
          <TeamEfficiencyHeatmap />
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 底部表格 -->
    <data-table ref="dataTable" :key="value" :activeType="value" />
  </div>
</template>

<script>
// 公共表格
import DataTable from './DataTable.vue'
// 工时统计分析
import WorkHourDistChart from './WorkHourDistChart.vue'
import WorkHourTrendChart from './WorkHourTrendChart.vue'
// 任务完成率
import TaskBarChart from './TaskBarChart.vue'  //岗位完成率排名
import TaskGaugeChart from './TaskGaugeChart.vue' //整体完成率
// 人均产出模块
import OutputTrendChange from './OutputTrendChange.vue' //产出趋势变化
import PerOutputRanking from './PerOutputRanking.vue' //人均产出排名
// 效率排名模块
import MultiRadar from './MultiRadar.vue'  //多维效率指标分析
import TeamEfficiencyHeatmap from './TeamEfficiencyHeatmap.vue'  //班组效率分布热力图

export default {
  components: {
    WorkHourDistChart,
    WorkHourTrendChart,
    DataTable,
    TaskBarChart,
    TaskGaugeChart,
    PerOutputRanking,
    OutputTrendChange,
    MultiRadar,
    TeamEfficiencyHeatmap
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data () {
    return {}
  },
  methods: {
    handleClick (tab, event) {
      this.value = tab.name
      console.log(tab.name, event, 'tab000',this.value,'this.value-0');
    }
  }
}
</script>

<style scoped>
.tabs-container {
  margin-bottom: 20px;
}
.charts-container {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.charts-container > div {
  width: 48%;
  height: 250px;
}
</style>